import { apolloClient } from '~/apollo-client';
import {
  Flex_CreatePersonalizedContractPreviewMutation,
  Flex_CreatePersonalizedContractPreviewMutationVariables,
  CreatePersonalizedContractPreviewInput,
} from '~/typings/graphql';
import { CREATE_PERSONALIZED_CONTRACT_PREVIEW } from './create-personalized-contract-preview.queries';

export interface CreatePersonalizedContractPreviewParams {
  contractVersionId: number;
  utilityAccountId: number;
  tabsData?: {
    houseOccupancy?: string;
    lmiProgram?: string[];
    county?: string;
    houseIncome?: string;
    lmiSourceSelection?: string[];
  };
}

export interface CreatePersonalizedContractPreviewResponse {
  base64: string;
}

export const createPersonalizedContractPreview = async (
  params: CreatePersonalizedContractPreviewParams,
): Promise<CreatePersonalizedContractPreviewResponse> => {
  const input: CreatePersonalizedContractPreviewInput = {
    contractVersionId: params.contractVersionId,
    utilityAccountId: params.utilityAccountId,
    tabsData: params.tabsData!,
  };

  const response = await apolloClient.mutate<
    Flex_CreatePersonalizedContractPreviewMutation,
    Flex_CreatePersonalizedContractPreviewMutationVariables
  >({
    mutation: CREATE_PERSONALIZED_CONTRACT_PREVIEW,
    variables: { input },
  });

  if (!response.data?.createPersonalizedContractPreview?.base64) {
    throw new Error('Failed to create personalized contract preview');
  }

  return { base64: response.data.createPersonalizedContractPreview.base64 };
};
